export default {
  token:'', //用户的token
  bangka:'', //当前用户是否绑卡
  hosDetail:'',
  active:0,
  jssdk:{},
  hosNmae:'沙洲尾社区卫生服务中心',
  userInfo:'', //默认就诊人信息
  userInfoList:[], //就诊人列表
  userDropList:{}, //就诊人下拉列表
  name: '',
  cacheArr: [],
  familyDocInfo: {}, //家庭医生数据存储
  isGo:'',
  checkUpDetail:"",
  checkOutDetail:"",
  deptid:0,//科室id
}
